/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityMelcoModelsError,
    IdentityMelcoModelsErrorFromJSON,
    IdentityMelcoModelsErrorToJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemToJSON,
} from '../models';

export interface UserPurchaseApiUserPurchaseDownloadRequest {
    melcoPaymentId: string;
    format?: string;
}

export interface UserPurchaseApiUserPurchaseGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    purchaseTypes?: string;
}

/**
 * 
 */
export class UserPurchaseApi extends runtime.BaseAPI {

    /**
     */
    async userPurchaseDownloadRaw(requestParameters: UserPurchaseApiUserPurchaseDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.melcoPaymentId === null || requestParameters.melcoPaymentId === undefined) {
            throw new runtime.RequiredError('melcoPaymentId','Required parameter requestParameters.melcoPaymentId was null or undefined when calling userPurchaseDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/purchases/{melco_payment_id}/invoices/download`.replace(`{${"melco_payment_id"}}`, encodeURIComponent(String(requestParameters.melcoPaymentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userPurchaseDownload(requestParameters: UserPurchaseApiUserPurchaseDownloadRequest): Promise<Blob> {
        const response = await this.userPurchaseDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userPurchaseGetListRaw(requestParameters: UserPurchaseApiUserPurchaseGetListRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.purchaseTypes !== undefined) {
            queryParameters['purchase_types'] = requestParameters.purchaseTypes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/purchases/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSON(jsonValue));
    }

    /**
     */
    async userPurchaseGetList(requestParameters: UserPurchaseApiUserPurchaseGetListRequest): Promise<IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem> {
        const response = await this.userPurchaseGetListRaw(requestParameters);
        return await response.value();
    }

}
